import { SvgIconClassKey, SvgIconProps } from "@material-ui/core/SvgIcon";
import { CSSProperties } from "@material-ui/styles/withStyles";

export const MuiSvgIconTheme: Partial<Record<SvgIconClassKey, CSSProperties>> = {};

export const MuiSvgIconProps: Partial<SvgIconProps> = {
  color: "inherit",
};
